// Simple browser TTS helper
export function speak(text, opts = {}) {
  if (typeof window === "undefined" || !("speechSynthesis" in window)) return;
  try {
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(text);
    // Slow down speech when dyslexia mode is on for clearer pronunciation
    const dyslexiaOn =
      typeof document !== "undefined" &&
      document.documentElement.classList.contains("dyslexia-mode");
    const baseRate = opts.rate ?? 0.85;
    utter.rate = dyslexiaOn ? Math.max(0.65, baseRate - 0.15) : baseRate;
    utter.pitch = opts.pitch ?? 1.1;
    utter.lang = opts.lang ?? "en-US";
    // Prefer an English voice if available
    const voices = window.speechSynthesis.getVoices();
    const enVoice = voices.find((v) => /en(-|_)?(US|GB)/i.test(v.lang));
    if (enVoice) utter.voice = enVoice;
    window.speechSynthesis.speak(utter);
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("[tts] speak failed:", err);
    }
  }
}
